import { FormControlLabel, FormLabel, Radio, RadioGroup, Stack, Tooltip } from '@mui/material';
import React, { useState } from 'react';
import { useAppDispatch } from '../../store/hooks';
import { setDuplicatePreference } from '../../store/upload/uploadSlice';
import { DuplicatePreference } from '../../types/generic';

interface DuplicateFieldProps {
	forceDisabled: boolean;
}

const DuplicateField: React.FC<DuplicateFieldProps> = ({ forceDisabled }) => {
	const dispatch = useAppDispatch();
	const [preference, setPreference] = useState<DuplicatePreference>('DISCARD');

	const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		setPreference((event.target as HTMLInputElement).value as DuplicatePreference);
		dispatch(setDuplicatePreference((event.target as HTMLInputElement).value as DuplicatePreference));
	};

	return (
		<Stack gap={1} padding="5px">
			<FormLabel id="duplicate-field-radio">Upon encountering a duplicate record, the processor should:</FormLabel>
			<Tooltip title="The processor will only find duplicates where all of the following attributes are the same: Operation, Suspect name, Reason for processing, Name and email address (including on behalf of someone else), File name, File contents, Key Phrases File">
				<RadioGroup
					row
					aria-label="duplicate field radio"
					data-testid="duplicate-field-radio"
					name="row-radio-buttons-group"
					value={preference}
					onChange={handleChange}
				>
					<FormControlLabel
						data-testid="duplicate-insert-option"
						value="INSERT"
						control={<Radio />}
						label="Insert anyway"
						disabled={forceDisabled}
					/>
					<FormControlLabel value="ASK" control={<Radio />} label="Ask before inserting" disabled={forceDisabled} />
					<FormControlLabel value="DISCARD" control={<Radio />} label="Discard" disabled={forceDisabled} />
				</RadioGroup>
			</Tooltip>
		</Stack>
	);
};

export default DuplicateField;
